var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStethoscopeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 3.89844V5.89844H6.5V9.89844C6.5 12.1075 8.29086 13.8984 10.5 13.8984C12.7091 13.8984 14.5 12.1075 14.5 9.89844V5.89844H12.5V3.89844H15.5C16.0523 3.89844 16.5 4.34616 16.5 4.89844V9.89844C16.5 12.8711 14.3381 15.3389 11.5008 15.8153L11.5 17.3984C11.5 19.3314 13.067 20.8984 15 20.8984C16.4973 20.8984 17.775 19.9582 18.2749 18.6359C17.2283 18.1684 16.5 17.1185 16.5 15.8984C16.5 14.2415 17.8431 12.8984 19.5 12.8984C21.1569 12.8984 22.5 14.2415 22.5 15.8984C22.5 17.2695 21.5802 18.4258 20.324 18.7838C19.7102 21.1504 17.5592 22.8984 15 22.8984C11.9624 22.8984 9.5 20.436 9.5 17.3984L9.50019 15.8155C6.66238 15.3395 4.5 12.8715 4.5 9.89844V4.89844C4.5 4.34616 4.94772 3.89844 5.5 3.89844H8.5ZM19.5 14.8984C18.9477 14.8984 18.5 15.3461 18.5 15.8984C18.5 16.4507 18.9477 16.8984 19.5 16.8984C20.0523 16.8984 20.5 16.4507 20.5 15.8984C20.5 15.3461 20.0523 14.8984 19.5 14.8984Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethoscopeIcon);
export default __webpack_public_path__ + "static/media/stethoscope-icon.c967d405df8940506674bba7547e37c0.svg";
export { ForwardRef as ReactComponent };